import { useTranslation } from 'react-i18next';
import useExperimentalFeature from 'hooks/useExperimentalFeature';

/**
 * Returns the translated CTA copy for the Quick Purchase button.
 * Resolves the active GrowthBook variant key and looks up its translation,
 * falling back to `purchase:title.buy_now` when no experiment is running.
 *
 * @returns {string} - The translated CTA copy
 */
const useQuickPurchaseCTAExperiment = () => {
  const { t } = useTranslation();
  const ctaVariantKey = useExperimentalFeature('QUICK_PURCHASE_CTA_COPY');
  return ctaVariantKey ? t(`purchase:title.${ctaVariantKey}`) : t('purchase:title.buy_now');
};

export default useQuickPurchaseCTAExperiment;
